import { type CurrencyName } from '@webapp/core/entities/external/Currency'

export interface FinancialAccountBalanceSummaryConstructor {
  totalAmount: string
  availableAmount: string
  allocatedAmount: string
  amountAllocatedToSpendingCards: string
  amountAllocatedToBillPayments: string
  currency: CurrencyName
  isInsufficient: boolean
}

export class FinancialAccountBalanceSummary {
  totalAmount: string
  availableAmount: string
  allocatedAmount: string
  amountAllocatedToSpendingCards: string
  amountAllocatedToBillPayments: string
  currency: CurrencyName
  isInsufficient: boolean

  constructor(data: FinancialAccountBalanceSummaryConstructor) {
    this.totalAmount = data.totalAmount
    this.availableAmount = data.availableAmount
    this.allocatedAmount = data.allocatedAmount
    this.amountAllocatedToSpendingCards = data.amountAllocatedToSpendingCards
    this.amountAllocatedToBillPayments = data.amountAllocatedToBillPayments
    this.currency = data.currency
    this.isInsufficient = data.isInsufficient
  }
}
